<template>
  <div class="leave-dialog-container">
    <el-dialog
      class="leave-dialog"
      :visible.sync="dialogShow"
      destroy-on-close
      :before-close="handleClose"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="leave-dialog-top">
        <p class="tit">办理离职</p>
        <i class="icon iconfont iconicon_close1 activeIconHover" @click="handleClose"></i>
      </div>

      <div class="leave-dialog-content" :class="{ 'unprocessed': unprocessedTasks }">
        <!-- <div class="unprocessed-tasks" v-if="unprocessedTasks">
          {{ `该员工还剩下 ${ unprocessedTasks } 个任务未处理` }}
        </div> -->
        <div class="staff-msg-warp">
          <Myavatar
            :userName="dataset.realname"
            :imgUrl="dataset.user_avatar"
            width="80px"
            height="80px"
            size="18px"
          ></Myavatar>
          <div class="staff-msg">
            <p class="name">{{ dataset.realname }}</p>
            <p class="number">工号：{{ dataset.job_number }}</p>
          </div>
        </div>

        <div class="staff-resource-handle-wrap">
          <p class="tit">将该员工拥有的资源</p>
          <div class="select-wrap">
            <el-radio-group v-model="radio">
              <el-radio :label="1">不处理</el-radio>
              <el-radio :label="2">转移给其他用户</el-radio>
              <el-radio :label="3">删除</el-radio>
            </el-radio-group>
            <div class="tis" v-if="radio && radio !== 2" :class="`handle-type-${ radio }`">
              <i class="icon iconfont iconicon_warning1"></i>
              {{ resourceHandleTis }}
            </div>
            <div class="handover-task-wrap" v-if="radio === 2">
              <wf-select
                departmentalStructure
                placeholder="搜索成员名称"
                :props="{value: 'uid', label: 'realname'}"
                :membersDataList="membersDataList"
                :membersUidArr="membersUidArr"
                v-model="dockingUserUid"
                @handleShowPanel="handleShowPanel"
                @change="leaderChange"
              >
                <template>
                  <el-input readonly v-model="dockingUser.realname" placeholder="请选择对接人">
                    <i
                      :class="{ showPanel }"
                      class="icon iconfont iconicon_drop_down_arrow rota90"
                      slot="suffix"
                    ></i>
                  </el-input>
                </template>
                <div slot="item" slot-scope="{ data }">
                  <Myavatar width="28px" height="28px" :imgUrl="data.user_avatar" :userName="data.realname">
                    <span>{{ data.realname }}</span>
                  </Myavatar>
                </div>
              </wf-select>
            </div>
          </div>
        </div>
      </div>

      <div class="leave-dialog-footer">
        <span class="cancel text-btn-active" @click="handleClose">取消</span>
        <wf-button
          type="primary"
          :disabled="btnDisabled"
          @click="handldeSubmit"
          :loading="btnLoading"
        >
          <!-- {{ radio === 2 ? '下一步' : '确定' }} -->
          确定
        </wf-button>
      </div>
    </el-dialog>

    <!-- <Handover-task-dialog
      :dialogShow="handoverTaskVisibile"
      :dataset="dataset"
      @handleClose="handoverDialogClose"
      @complete="handleResign"
    ></Handover-task-dialog> -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
// components
// import HandoverTaskDialog from './handoverTaskDialog.vue'
// api
import api from '@/services/api/staffManagement/staffManagement'
import apiTask from '@/services/api/task/task'

export default  {
  // components: {
  //   HandoverTaskDialog
  // },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    dataset: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    ...mapState('department/department', {
      departmentgroup: state => state.projectList.departmentgroup
    }),
    membersDataList() {
      let obj = {}
      if (this.departmentgroup?.length) {
        this.departmentgroup.forEach(item => {
          obj[item.name] = item.member
        })
      }
      return obj
    },
    membersUidArr() {
      let arr = []
      if (this.departmentgroup?.length) {
        this.departmentgroup.forEach(item => {
          item.member.forEach(item2 => {
            arr.push(item2.uid)
          })
        })
      }
      return arr
    },
    // 员工资源处理tis
    resourceHandleTis() {
      return this.radio === 1 ? '该员工拥有的任务将变为待认领状态' : this.radio === 3 ? '该员工拥有的任务均将删除，请谨慎操作。' : ''
    },
    // 保存按钮是否置灰
    btnDisabled() {
      return !this.radio || (this.radio === 2 && !this.dockingUser.uid)
    }
  },
  watch: {
    dialogShow(val) {
      if (val) {
        if (!this.departmentgroup?.length) {
          this.getDepartmentUser()
        }
        this.resetForm()
      }
    }
  },
  data() {
    return {
      radio: 0,
      btnLoading: false,
      showPanel: false, // 下拉成员选框是否展开
      unprocessedTasks: 0, // 未完成任务数
      handoverTaskVisibile:  false, // 转移任务弹窗开关
      dockingUser: {}, // 交接人
      dockingUserUid: 0, // 交接人id
      // 加载所有成员列表
      loadProjectMembers: async (resolve, params) => {
        let membersArr = []
        const param = {
          working_status: '在职',
          ...params
        }
        const result = await apiTask.getProjectMembers(param)
        if (result) {
          result.forEach(res => {
            for (let key in res) {
              if (res[key].length) {
                membersArr.push(...res[key]) //获取成员形成一个数组
              }
            }
          })
          resolve(membersArr)
        }
      }
    }
  },
  methods: {
    ...mapActions('department/department', ['getDepartmentUser']),
    resetForm() {
      this.radio = 0
      this.unprocessedTasks = 0
      this.dockingUser = {}
      this.dockingUserUid = 0
    },
    handleClose() {
      this.resetForm()
      this.$emit('handleClose')
    },
    handleShowPanel(val) {
      this.showPanel = val
    },
    leaderChange(item) {
      this.dockingUser = item
    },
    handldeSubmit() {
      // if (this.radio === 2) {
      //   // 转移任务
      //   this.handoverTaskVisibile = true
      // } else {
        this.btnLoading = true
        this.$wfAlert('', `确认对 ${ this.dataset.realname } 办理离职？`, '', '确定').then(() => {
          this.handleResign()
        }).catch(() => {
          console.log('执行异常')
          this.btnLoading = false
          next(false)
        })
      // }
    },
    async handleResign() {
      const param = {
        uid: this.dataset.uid,
        action: this.radio === 2 ? 'handover' : 'unhandled',
        receive_uid: this.radio === 2 ? this.dockingUser.uid : ''
        // action: this.radio === 1 ? 'unhandled' : this.radio === 3 ? 'delete' : ''
      }
      // console.log(param, 1111)
      try {
        const res = await api.userResign(param)
        if (res) {
          this.$message({
            message: '该用户办理离职成功',
            type: 'success'
          })
          this.btnLoading = false
          this.resetForm()
          this.$emit('handleSuccess')
        }
      } catch (error) {
        this.btnLoading = false
      }

    },
    // 交接任务弹窗关闭
    handoverDialogClose(unprocessedTasks) {
      this.unprocessedTasks = unprocessedTasks
      this.handoverTaskVisibile = false
    },
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.leave-dialog-container {
  .leave-dialog {
    .el-dialog {
      width: 464px;
      .el-dialog__header {
        padding: 0 !important;
      }
      .el-dialog__body {
        padding: 0 !important;
        .leave-dialog-top {
          width: 100%;
          padding: 16px 24px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .tit {
            font-size: 18px;
            line-height: 22px;
          }
        }
        .leave-dialog-content {
          padding: 24px;
          box-sizing: border-box;
          border-top: 1px solid rgba(32, 32, 32, .08);
          border-bottom: 1px solid rgba(32, 32, 32, .08);
          &.unprocessed {
            position: relative;
            border-top: none;
            padding-top: 84px;
          }
          .unprocessed-tasks {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 48px;
            background: #EEEEEE;
            font-size: 14px;
            @include fontColorOpacity(.6);
            line-height: 48px;
            padding-left: 21px;
            box-sizing: border-box;
          }
          .staff-msg-warp {
            display: flex;
            align-items: center;
            margin-bottom: 40px;
            .avatar-box {
              margin-right: 24px;
            }
            .staff-msg {
              padding-top: 8px;
              .name {
                font-size: 24px;
                font-weight: 500;
                line-height: 33px;
                margin-bottom: 12px;
              }
              .number {
                font-size: 14px;
                line-height: 20px;
                @include fontColorOpacity(.6);
              }
            }
          }
          .staff-resource-handle-wrap {
            .tit {
              font-size: 14px;
              line-height: 20px;
              @include fontColorOpacity(.6);
            }
            .select-wrap {
              margin-top: 14px;
              .el-radio-group {
                width: 100%;
                margin-bottom: 12px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .el-radio {
                  font-size: 14px;
                  line-height: 20px;
                  @include fontColorOpacity(1);
                  .el-radio__label {
                    padding-left: 8px;
                  }
                  &:last-child {
                    visibility: hidden;
                  }
                }
              }
              .handover-task-wrap {
                .wf-select {
                  .el-input__inner {
                    height: 40px;
                    line-height: 40px;
                  }
                  .el-input__suffix {
                    line-height: 40px;
                    .rota90 {
                      transition: all .3s;
                      &.showPanel {
                        transform: rotate(-90deg) !important;
                      }
                    }
                  }
                }
              }
              .tis {
                width: 100%;
                height: 40px;
                border-radius: 4px;
                padding-left: 17px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                position: relative;
                i {
                  margin-right: 8px;
                }
                &.handle-type-1 {
                  background: #EEEEEE;
                  border-radius: 0 4px 4px 4px;
                  @include fontColorOpacity(.6);
                  i {
                    @include fontColorOpacity(.4);
                  }
                  &::before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: -6px;
                    display: block;
                    width: 7px;
                    height: 7px;
                    background: linear-gradient(45deg, #eee, #eee 50%, transparent 50%, transparent 100%);
                  }
                }
                &.handle-type-3 {
                  background: #FEE6E6;
                  color: #FF3939;
                  i {
                    color: #FF3939;
                  }
                  &::before {
                    content: '';
                    position: absolute;
                    right: 36px;
                    top: -13px;
                    display: block;
                    width: 0;
                    height: 0;
                    border: 7px solid transparent;
                    border-bottom-color: #FEE6E6;
                  }
                }
              }
            }
          }
        }
        .leave-dialog-footer {
          width: 100%;
          height: 64px;
          padding: 16px 24px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .wf-button {
            width: 76px;
            margin-left: 24px;
          }
        }
      }
    }
  }
}
</style>
